module.exports = __webpack_public_path__ + "img/12.9d9491e6.jpg";